export const SalesForceFeatures = [
    { name: "Custom Fields", type: "Yes" },
    { name: "Full Call Centre Software", type: "3rd Party" },
    { name: "Integrated WhatsApp For Business Support (with full Automation like MakeMyTrip)*", type: "3rd Party" },
    { name: "Workflow Management - Automate lead & sales management", type: "Yes" },
    { name: "Booking Form with Support for Agreement + Brokerage Calculations", type: "3rd Party" },
    { name: "Insta Connect - For Instant Auto connected Call back to Customers", type: "No" },
    { name: "Create & Track Price Quotes", type: "3rd Party" },
    { name: "Schemes & Discounts", type: "3rd Party" },
    { name: "Connected Facebook Adverts Tracking - Auto CPL calculations & Dashboards", type: "Marketing Product - Pardot (Cost upwards of Rs. 75L/year)" },
    { name: "Drip Marketing", type: "Marketing Product - Pardot (Cost upwards of Rs. 75L/year)" },
    { name: "Inventory management - projects, towers, configurations and units", type: "3rd Party" },
    { name: "Customer Access & Online Interface", type: "No" },
    { name: "Online Bookings, Schemes & Discounts", type: "No" },
    { name: "ISO 27001 Certified Data Security & Compliance", type: "Yes" }
];
export default SalesForceFeatures;
